import React, { useState, useEffect } from "react";
import Modal from "../../../components/modal";
import { Minus, Plus } from "lucide-react";
import { data } from "autoprefixer";
import Select from 'react-select';
import { updateFormData } from "../../../slices/admin/companySlice";

const AddFinalProduct = ({ show, onClose, heading, initialData = [], onSubmit, finalCategory = [], categories = [], rawProducts = [], units = [] }) => {
    // name	sku	unit	hsn_sac	gst	raw_products	purchase_cost	sale_cost	gst_included	is_mrp	
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [purchase_cost, setPurchaseCost] = useState(0);
    const [isRawProducts, setIsRawProducts] = useState(false);
    const [finalSelectedcat, setFinalSelectedCat] = useState([]);
    const [formData, setFormData] = useState({
        name: '',
        sku: '',
        unit: '',
        final_category: '',
        hsn_sac: '',
        raw_products: [{ id: '', quantity: '' }],
        product_image: '',
        sale_cost: '',
        gst_included: '',
        is_mrp: '',

    });

    useEffect(() => {
        if (initialData) {
            console.log('initial data', initialData);
            const rawProducts = initialData?.finalRawProducts
                ? initialData.finalRawProducts.map((prod) => ({
                    id: prod.raw_product_id,
                    quantity: prod.quantity,
                }))
                : [{ id: '', quantity: '' }];
            
            if(rawProducts){
                setIsRawProducts(true);
            }

            setFinalSelectedCat(initialData?.FinalCategory);

            setFormData({
                name: initialData.name || '',
                sku: initialData.sku || '',
                unit: initialData.unit || '',
                final_category: initialData.final_category || '',
                hsn_sac: initialData.hsn_sac || '',
                raw_products: rawProducts, // Set raw_products as parsed JSON or array
                product_image: initialData.product_image || '',
                sale_cost: initialData.sale_cost || '',
                gst_included: initialData.gst_included || '',
                is_mrp: initialData.is_mrp || '',
            });
            if (initialData?.category) {
                setSelectedCategory(JSON.parse(initialData?.category));
            }
            setPurchaseCost(initialData?.purchase_cost);
        }
    }, [initialData]); // Ensure this runs when initialData changes


    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        setFormData((prevFormData) => {
            const updatedFormData = { ...prevFormData };

            if (type == 'checkbox') {
                updatedFormData[name] = checked ? 1 : 0;
            } else if (type == 'file') {
                updatedFormData[name] = files[0]; // Store the file in formData
            } else {
                updatedFormData[name] = value; // For other input types, just store the value
            }

            // Auto-generate the slug if the name field is being edited
            if (name === 'name') {
                const slug = value
                    .toLowerCase() // Convert to lowercase
                    .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric characters with hyphens
                    .replace(/^-+|-+$/g, ''); // Remove leading and trailing hyphens

                updatedFormData.slug = slug; // Update the slug in the same formData object
            }

            if (name === 'final_category') {
                const finalCat = finalCategory.find((item) => item.id === parseInt(value, 10));
                console.log('Selected Final Category:', finalCat);

                if (finalCat) {
                    updatedFormData.hsn_sac = finalCat.hsn_code;
                    updatedFormData.unit = finalCat.unit;
                } else {
                    // Reset hsn_sac and unit if no matching category is found
                    updatedFormData.hsn_sac = '';
                    updatedFormData.unit = '';
                }
            }

            return updatedFormData; // Return the updated state
        });
    };
    // Handle change for multiple fields (suppliers, purchase_costs)
    const handleDynamicChange = (e, index, field) => {
        const { value } = e.target;
        const updatedSuppliers = formData.raw_products.map((raw_product, idx) =>
            idx === index ? { ...raw_product, [field]: value } : raw_product
        );
        setFormData({ ...formData, raw_products: updatedSuppliers });
    };

    const handleCategoryChange = (selectedOptions) => {
        const selectedValues = selectedOptions.map(option => option.value);
        setSelectedCategory(selectedValues);
        console.log(selectedValues); // Correctly set the state with the array of selected values
    };

    // Handle adding a new supplier row
    const handleAddRow = () => {
        setFormData({
            ...formData,
            raw_products: [...formData.raw_products, { id: '', quantity: '' }] // Add a new empty row
        });
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        const formPayload = new FormData();

        const company = JSON.parse(localStorage.getItem('company'));

        // Loop through the formData and append the fields to formPayload
        let totalPurchaseCost = 0; // Total purchase cost for all selected raw products
        for (let key in formData) {
            if (formData.hasOwnProperty(key)) {
                // If key is raw_products and is an array, handle it separately
                if (key === 'raw_products' && Array.isArray(formData[key])) {
                    // Check if raw_products is an array and not empty
                    if (formData[key] && formData[key].length > 0) {
                        formPayload.append(key, JSON.stringify(formData[key]));

                        // Loop through the selected raw products and calculate the lowest purchase cost
                        formData.raw_products.forEach((es) => {
                            // Find the product in rawProducts by matching the id
                            const rawProd = rawProducts.find((prod) => prod.id == es.id);

                            if (rawProd && rawProd.RawProductVendors && rawProd.RawProductVendors.length > 0) {
                                // Find the lowest purchase cost in RawProductVendors
                                const lowestPurchaseCost = Math.min(
                                    ...rawProd.RawProductVendors.map(vendor => vendor.purchase_cost)
                                );

                                // Add the lowest purchase cost to the total purchase cost
                                totalPurchaseCost += (parseInt(lowestPurchaseCost) * parseInt(es.quantity));
                            }
                        });
                    }
                } else {
                    // For other fields, append the value directly (check for undefined)
                    if (formData[key] !== undefined) {
                        formPayload.append(key, formData[key]);
                    }
                }
            }
        }

        // Append the total purchase cost
        formPayload.append('purchase_cost', totalPurchaseCost);
        formPayload.append('category', JSON.stringify(selectedCategory));
        // Append the company_id if it exists in localStorage
        if (company) {
            formPayload.append('company_id', company?.company?.id);
        }

        // Reset the formData state after submission
        setFormData({
            name: '',
            sku: '',
            unit: '',
            final_category: '',
            hsn_sac: '',
            raw_products: [{ id: '', quantity: '' }],
            product_image: '',
            sale_cost: '',
            gst_included: '',
            is_mrp: '',
        });

        // Call the onSubmit function with the formPayload
        onSubmit(formPayload);
    };


    const getPurchaseCost = () => {
        let totalCost = 0;
        formData.raw_products && formData.raw_products.forEach((es) => {
            const rawProd = rawProducts.find((prod) => prod.id == es.id);

            if (rawProd && rawProd.RawProductVendors && rawProd.RawProductVendors.length > 0) {
                // Find the lowest purchase cost, making sure it's a valid number
                const lowestPurchaseCost = Math.min(
                    ...rawProd.RawProductVendors.map(vendor => parseFloat(vendor.purchase_cost) || 0)
                );

                // Ensure valid quantity
                const quantity = parseInt(es.quantity);
                if (!isNaN(lowestPurchaseCost) && !isNaN(quantity)) {
                    totalCost += (lowestPurchaseCost * quantity); // Accumulate total purchase cost
                }
            }
        });
        setPurchaseCost(totalCost);
    }


    const filterRawProducts = selectedCategory.length > 0
        ? rawProducts.filter((product) => {
            console.log('Comparing category:', product.category, 'with selectedCategory:', selectedCategory);
            return selectedCategory.includes(parseInt(product.category)); // Match categories
        })
        : rawProducts;


    const categoryOptions = categories.map((cat) => ({
        value: cat.id,
        label: cat.name
    }));


    const getUnit = (id, product) => {
        const prod = product.find((e) => e.id == id);
        if (prod) {
            return prod.RawCategory?.Unit?.name;
        }
        return "";
    }

    return (
        <Modal
            show={show}
            onClose={onClose}
            heading={heading}
        >
            <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Name</label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter Name"
                                required
                            />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Product Code</label>
                            <input
                                type="text"
                                name="sku"
                                className="form-control"
                                value={formData.sku}
                                onChange={handleChange}
                                placeholder="Enter SKU"
                            />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Product Image</label>
                            <input
                                type="file"
                                name="product_image"
                                className="form-control"
                                onChange={handleChange}
                                placeholder="Select Image"
                                accept=".png/.jpeg"
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>Category</label>
                            <select
                                name="final_category"
                                value={formData.final_category}
                                className="form-control"
                                onChange={handleChange}
                            >
                                <option>Select Category</option>
                                {finalCategory.map((un) => (
                                    <option key={un.id} value={un.id}>
                                        {un.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>HSN/SAC</label>
                            <input
                                type="text"
                                name="hsn_sac"
                                className="form-control"
                                value={formData.hsn_sac}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label>Unit</label>
                            <div className="input-group">

                                {/* <select
                                    name="unit"
                                    value={formData.unit}
                                    className="form-control"
                                    onChange={handleChange}
                                >
                                    <option>Select Unit</option>
                                    {units.map((un) => (
                                        <option key={un.id} value={un.name}>
                                            {un.name}
                                        </option>
                                    ))}
                                </select> */}
                                <input
                                    type="text"
                                    readOnly
                                    // name="unit_quantity"
                                    className="form-control"
                                    value={formData.unit}
                                    placeholder="Unit"
                                    required
                                />
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-md-12">
                        <div className="form-group mb-2">
                            <input
                                type="checkbox"
                                name="is_mrp"
                                className="form-check-input"
                                checked={formData.is_mrp}
                                onChange={handleChange}
                                placeholder="Enter Tax Included"
                            />
                            <label className="ms-2">Is MRP</label>

                        </div>
                    </div> */}
                    <div className="col-md-12">
                        <div className="form-check mb-2">
                            <input
                                type="checkbox"
                                name="gst_included"
                                className="form-check-input"
                                checked={formData.gst_included}
                                onChange={handleChange}
                                placeholder="Enter Gst Included"
                            />
                            <label className="form-check-label ms-2">Is GST Included</label>

                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="form-check mb-4">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                checked={isRawProducts}
                                onChange={(e) => setIsRawProducts(e.target.checked)}
                            />
                            <label className="form-check-label ms-2">Is Raw Products</label>

                        </div>
                    </div>

                    {isRawProducts && (
                        <>
                            <div className="col-md-12">
                                <div className="form-group mb-4">
                                    <label>Raw Category</label>
                                    {/* <input
                                type="text"
                                name="category"
                                className="form-control"
                                value={formData.category}
                                onChange={handleChange}
                                placeholder="Enter Category"
                            /> */}
                                    {/* <select
                                name="category"
                                className="form-control"
                                value={formData.category}
                                onChange={handleCategoryChange}
                                required
                                multiple
                            >
                                <option value="">Select Category</option>
                                {categories.map((cat) => (
                                    <option key={cat.id} value={cat.id}>
                                        {cat.name}
                                    </option>
                                ))}
                            </select> */}

                                    <Select
                                        name="category"
                                        isMulti
                                        options={categoryOptions}
                                        value={categoryOptions.filter(option => selectedCategory.includes(option.value))}
                                        onChange={handleCategoryChange}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        placeholder="Select Raw Category"
                                    />

                                </div>
                            </div>

                            <div className="col-md-12">
                                <div className="row">
                                    {/* Render all supplier-cost pairs */}
                                    {formData.raw_products && formData.raw_products.map((raw_products, index) => {
                                        const selectedSupplierIds = formData.raw_products.filter((_, idx) => idx !== index).map(sup => parseInt(sup.name)); // Collect selected supplier IDs
                                        // console.log(selectedSupplierIds);
                                        return (
                                            <React.Fragment key={index}>
                                                <div className="col-md-5">
                                                    <div className="form-group mb-4">
                                                        <label>Raw Product</label>
                                                        <select
                                                            name="id"
                                                            className="form-control"
                                                            value={raw_products.id}
                                                            onChange={(e) => handleDynamicChange(e, index, 'id')}

                                                        >
                                                            <option value="">Select Raw Product</option>
                                                            {filterRawProducts.map((product) => (
                                                                <option key={product.id} value={product.id}>
                                                                    {product.name}
                                                                </option>
                                                            ))}
                                                        </select>

                                                    </div>
                                                </div>

                                                <div className="col-md-5">
                                                    <div className="form-group mb-4">
                                                        <label>Quantity</label>
                                                        <div className="input-group mb-2">
                                                            <input
                                                                type="number"
                                                                name="quantity"
                                                                className="form-control"
                                                                value={raw_products.quantity}
                                                                onChange={(e) => handleDynamicChange(e, index, 'quantity')}
                                                                placeholder="Enter Quantity"
                                                            />
                                                            {getUnit(raw_products.id, filterRawProducts) && (<div className="input-group-prepend">
                                                                <div className="input-group-text">{getUnit(raw_products.id, filterRawProducts)}</div>
                                                            </div>)}
                                                        </div>
                                                    </div>
                                                </div>


                                                {(
                                                    index != 0 ? (
                                                        <div className="col-md-2">
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger mt-4"
                                                                onClick={() => {
                                                                    const updatedSuppliers = formData.raw_products.filter(
                                                                        (_, idx) => idx !== index
                                                                    );
                                                                    setFormData({ ...formData, raw_products: updatedSuppliers });
                                                                }}
                                                            >
                                                                <Minus />
                                                            </button>
                                                        </div>
                                                    ) : (<div className="col-md-2">
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary mt-4"
                                                            onClick={handleAddRow}
                                                        >
                                                            <Plus />
                                                        </button>
                                                    </div>)
                                                )}

                                            </React.Fragment>
                                        );
                                    })}

                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="form-group mb-4">
                                    <label className="ms-2">Average Purchase Cost</label>
                                    <div className="input-group mb-2">
                                        <div className="input-group-prepend">
                                            <div className="input-group-text">₹</div>
                                        </div>
                                        <input
                                            type="text"
                                            name="purchase_cost"
                                            className="form-control"
                                            value={purchase_cost > 0 ? purchase_cost : ''}
                                            readOnly
                                        />
                                    </div>
                                    {/* Button to calculate purchase cost */}
                                    <button
                                        type="button"
                                        className="btn btn-primary mt-3"
                                        onClick={getPurchaseCost}
                                    >
                                        Calculate Purchase Cost
                                    </button>
                                </div>
                            </div>
                        </>
                    )}

                    <div className="col-md-6">
                        <div className="form-group mb-4">
                            <label className="ms-2">Sale Cost</label>
                            <div className="input-group mb-2">
                                <div className="input-group-prepend">
                                    <div className="input-group-text">₹</div>
                                </div>
                                <input
                                    type="text"
                                    name="sale_cost"
                                    className="form-control"
                                    value={formData.sale_cost}
                                    onChange={handleChange}
                                    placeholder="Enter Sale Cost"
                                />
                            </div>

                        </div>
                    </div>
                    <hr></hr>
                    <div className="col-md-12">
                        <table className="table ">
                            <tr>
                                <td className="text-end">
                                   <strong> Sale Cost: &nbsp;&nbsp; </strong>
                                </td>
                                <td width={"150px"}><input readOnly className="form-control m-1" value={`₹ ${formData.sale_cost}`}/></td>
                            </tr>
                            <tr>
                                <td className="text-end">
                                   <strong> GST %: &nbsp;&nbsp; </strong>
                                </td>
                                <td width={"150px"}><input readOnly className="form-control m-1" value={`${finalSelectedcat?.gst} % - ${formData.gst_included?"included":"Excluded"}`}/></td>
                            </tr>
                            <tr>
                                <td className="text-end">
                                   <strong> Final Cost With Tax: &nbsp;&nbsp; </strong>
                                </td>
                                <td width={"150px"}><input readOnly className="form-control m-1" value={`₹ ${(formData?.sale_cost * (1 + (formData.gst_included?0:finalSelectedcat?.gst) / 100)).toFixed(2)}`}/></td>
                            </tr>
                        </table>
                    </div>

                </div>

                <div className="d-flex justify-content-end mt-4">
                    <button
                        type="button"
                        className="btn btn-light me-2"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                        Save
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default AddFinalProduct;
